var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('helio-button',{staticClass:"button-block",attrs:{"link":_vm.block.content.url,"text":_vm.block.content.text}})}
var staticRenderFns = []

export { render, staticRenderFns }